import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kjbm",
  "use": "icon-kjbm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-kjbm\"><defs><style type=\"text/css\"></style></defs><path d=\"M731.428571 0c161.572571 0 292.571429 130.998857 292.571429 292.571429v438.857142c0 161.572571-130.998857 292.571429-292.571429 292.571429H292.571429C130.998857 1024 0 893.001143 0 731.428571V292.571429C0 130.998857 130.998857 0 292.571429 0h438.857142z m47.85981 733.305905H467.090286l-44.544 45.909333h356.742095v-45.909333zM533.820952 344.33219L244.053333 664.624762v114.566095h111.518477L645.36381 458.581333l-111.542858-114.249143z m89.404953-91.91619l-66.974476 68.632381 111.494095 114.541714 66.730666-68.608c10.922667-11.215238 10.922667-34.450286 0-45.933714l-66.706285-68.608c-11.215238-11.215238-33.645714-11.215238-44.544 0z\" fill=\"#afa208\" p-id=\"3739\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kjbm.svg
// module id = JKIc
// module chunks = 1